// extracted by mini-css-extract-plugin
export var body = "_bz-0";
export var sectionHeader = "_bz-4";
export var shortcutColumns = "_bz-2";
export var shortcutList = "_bz-1";
export var shortcutSection = "_bz-3";